import React, { useState,useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import API_BASE_URL from "../config/api";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";

export default function SignInPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const { setIsLoggedIn } = useContext(AuthContext);
  const handleChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // call your auth endpoint
      const { data } = await axios.post(API_BASE_URL + "auth/login", form);
      console.log("Login response:", data);
      localStorage.setItem("token", data.token);
      setIsLoggedIn(true);
      navigate("/profile");
    } catch (err) {
      setError(err.response?.data?.msg || "Login failed");
    }
  };

  return (
    <div className="container py-5" style={{ maxWidth: "400px" }}>
      <h2 className="mb-4 text-center">Sign In</h2>
      {error && <div className="alert alert-danger">{error}</div>}
      <form onSubmit={handleSubmit} noValidate>
        <div className="mb-3">
          <label htmlFor="signin-email" className="form-label">
            Email
          </label>
          <input
            type="email"
            id="signin-email"
            name="email"
            className="form-control"
            value={form.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-4">
          <label htmlFor="signin-password" className="form-label">
            Password
          </label>
          <input
            type="password"
            id="signin-password"
            name="password"
            className="form-control"
            value={form.password}
            onChange={handleChange}
            required
          />
        </div>
        <button className="btn btn-primary w-100 mb-3">Sign In</button>
      </form>
      <p className="text-center">
        Don’t have an account? <Link to="/signup">Sign Up</Link>
      </p>
    </div>
  );
}
